"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "LocalStrategy", {
    enumerable: true,
    get: function() {
        return LocalStrategy;
    }
});
const _passportlocal = require("passport-local");
const _passport = require("@nestjs/passport");
const _common = require("@nestjs/common");
const _config = require("@nestjs/config");
const _nocodbsdk = require("nocodb-sdk");
const _authservice = require("~/modules/auth/auth.service");
const _catchError = require("~/helpers/catchError");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let LocalStrategy = class LocalStrategy extends (0, _passport.PassportStrategy)(_passportlocal.Strategy) {
    async validate(username, password) {
        if (this.config.get('auth.disableEmailAuth', {
            infer: true
        })) _catchError.NcError.forbidden('Not available');
        const user = await this.authService.validateUser(username, password);
        if (!user) {
            _catchError.NcError.badRequest('Invalid credentials');
        }
        user.roles = (0, _nocodbsdk.extractRolesObj)(user.roles);
        return user;
    }
    constructor(authService, config){
        super({
            usernameField: 'email',
            passwordField: 'password'
        }), this.authService = authService, this.config = config;
    }
};
LocalStrategy = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _authservice.AuthService === "undefined" ? Object : _authservice.AuthService,
        typeof _config.ConfigService === "undefined" ? Object : _config.ConfigService
    ])
], LocalStrategy);
